export default __webpack_public_path__ + "static/media/punte alberete 3 P.e8f59c4c.mp3";